import axios from "axios";

const API_URL = process.env.REACT_APP_SERVER_URL;

/**
 * Load upcoming offline classes from backend.
 * Default: next 30 days ahead.
 *
 * Optional params:
 *   from (Date)
 *   to   (Date)
 *   mode = "offline" | "online" (default: offline)
 *   token (optional for auth)
 */
export const getClasses = async ({
  from,
  to,
  type = "offline",
  token,
} = {}) => {
  const baseUrl = `${process.env.REACT_APP_SERVER_URL}/classes`;
  // Default range = today → +30 days
  const start = from || new Date();
  const end = to || new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);

  // Query params
  const params = new URLSearchParams({
    from: start.toISOString(),
    to: end.toISOString(),
    type,
  });

  const apiUrl = `${baseUrl}?${params.toString()}`;

  try {
    const response = await axios.get(apiUrl, {
      headers: token
        ? {
            Authorization: `Bearer ${token}`,
          }
        : {},
    });
    console.log('RESPONSE')
    console.log(response.data)
    return response.data; // array of class objects
  } catch (error) {
    console.error("Error fetching classes:", error.response || error);
    throw error;
  }
};

export const getUpcomingClasses = async (token) => {
  try {
    const headers = {};
    if (token) headers.Authorization = `Bearer ${token}`;
    const res = await fetch(`${API_URL}/classes/upcoming`, { headers });
    if (!res.ok) throw new Error("Failed to fetch classes");
    return await res.json();
  } catch (error) {
    console.error("Error fetching classes:", error);
    return [];
  }
};

export const bookClass = async (classId, token, options = {}) => {
  const res = await fetch(`${API_URL}/classes/${classId}/book`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ online: options.online === true }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || "Failed to book class");
  }
  return await res.json();
};

export const cancelBooking = async (classId, token) => {
  try {
    const res = await fetch(`${API_URL}/classes/${classId}/cancel`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) throw new Error("Failed to cancel booking");
    return await res.json();
  } catch (error) {
    console.error("Error cancelling booking:", error);
    throw error;
  }
};

export const updateMyBookingOnline = async (classId, token, online) => {
  const res = await fetch(`${API_URL}/classes/${classId}/booking-online`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ online }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || "Failed to update booking");
  }
  return res.json();
};

export const joinWaitlist = async (classId, token) => {
  const res = await fetch(`${API_URL}/classes/${classId}/waitlist`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || "Failed to join waiting list");
  }
  return res.json();
};

export const leaveWaitlist = async (classId, token) => {
  const res = await fetch(`${API_URL}/classes/${classId}/waitlist`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || "Failed to leave waiting list");
  }
  return res.json();
};

